import { EnvironmentProviders, importProvidersFrom } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { HashtagInfoEffects } from './store/hashtag-info.effects';
import {
    hashtagInfoFeatureKey,
    hashtagInfoReducer,
} from './store/hashtag-info.reducer';

export function provideHashtagInfoStore(): EnvironmentProviders {
    return importProvidersFrom(
        StoreModule.forFeature(hashtagInfoFeatureKey, hashtagInfoReducer),
        EffectsModule.forFeature(HashtagInfoEffects),
    );
}
